import { render, staticRenderFns } from "./online_aftersale_list.vue?vue&type=template&id=3f42ed6e&scoped=true"
import script from "./online_aftersale_list.vue?vue&type=script&lang=js"
export * from "./online_aftersale_list.vue?vue&type=script&lang=js"
import style0 from "./online_aftersale_list.vue?vue&type=style&index=0&id=3f42ed6e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f42ed6e",
  null
  
)

export default component.exports